import createAction from "../../app/createAction";
import { PUSH_GTM_EVENT_START } from "./googleTagManagerConstants";

export const pushGtmEventAction = (payload) => createAction(PUSH_GTM_EVENT_START, payload);